import { render, staticRenderFns } from "./comprehension.config.vue?vue&type=template&id=22d1befc"
import script from "./comprehension.config.vue?vue&type=script&lang=js"
export * from "./comprehension.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports